import type { IAnalyticsPropContext } from '@inter-ikea-kompis/analytics';
import { AbstractAnalyticsTracker } from '@inter-ikea-kompis/analytics';
import type { IDexfSettings, IShoppingItem } from '@inter-ikea-kompis/types';

import { IpexMomentEnum } from '@insights/insights-data-provider';

const moduleId = 'add_to_bag';

/**
 * Tracks events from Add to bag and sends them to a reporter.
 *
 * @event click When add to cart or add to wishlist buttons are clicked.
 * @event handle_unavailable_items Triggered when clicking an action in the unavailable products dialog
 */
export default class AddToBagTracker extends AbstractAnalyticsTracker {
	private readonly context?: IAnalyticsPropContext['context'];

	constructor(options: {
		dev: boolean;
		ab?: boolean;
		settings: IDexfSettings;
		locale: string;
		reporterId?: string;
		context?: IAnalyticsPropContext['context'];
	}) {
		super({ moduleId, ...options });
		this.context = options.context;
	}

	/**
	 * Call to report when clicking to add products to the shopping cart.
	 */
	public sendAddToCartClick(): void {
		const payload = {
			common: { component: moduleId },
			data: {
				action: 'add_to_cart'
			},
			context: this.context
		};
		this.getReporter().report({
			event: 'click',
			ipexMoment: IpexMomentEnum.giveMe,
			payload
		});
	}

	/**
	 * Call to report when clicking an action in the unavailable products dialog.
	 *
	 * @param unavailableArticles ...
	 * @param addUnavailableToWishList ...
	 * @param action ...
	 */
	public sendHandleUnavailableItems(
		unavailableArticles: IShoppingItem[],
		addUnavailableToWishList: boolean,
		action: 'cancel' | 'continue'
	): void {
		const payload = {
			common: { component: moduleId },
			data: {
				// eslint-disable-next-line camelcase
				add_unavailable_to_wishlist: addUnavailableToWishList,
				articles: unavailableArticles,
				action
			},
			context: this.context
		};

		this.getReporter().report({
			event: 'handle_unavailable_items',
			ipexMoment: action === 'continue' ? IpexMomentEnum.giveMe : IpexMomentEnum.whatIsMe,
			payload
		});
	}
}
